"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDropletDestroyStatus = void 0;
const getDropletDestroyStatus = ({ httpClient, }) => ({ droplet_id, }) => {
    const path = '/droplets';
    const url = `${path}/${droplet_id}/destroy_with_associated_resources/status`;
    return httpClient.get(url);
};
exports.getDropletDestroyStatus = getDropletDestroyStatus;
//# sourceMappingURL=get-droplet-destroy-status.js.map